import React, { Fragment } from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./ProHistoryGridConfig";
import { withStyles, Button } from "@material-ui/core";
import styles from "../../Settings/styles";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../appMessages";
import { AppLoading } from "../../../../loaders/loaders";
import SearchBox from "../../../common/SearchBox";
import ProHistoryHeader from "./ProHistoryHeader";

class ProHistoryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      commonData: {},
      gridData: [],
      searchedPro: "",
      loading: false
    };
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateSearchText = (searchedPro) => {
    this.setState({searchedPro});
  };

  resetData = () => {
    this.setState({
      commonData:{},
      gridData: [],
      loading: false
    });
  };

  fetchProHistory = () => {
    const { searchedPro } = this.state;

    this.setState({
      loading: true
    });
    
    if (searchedPro) {
      getDataWithQueryString("GetProHistory", `proId=${searchedPro}`).then(
        response => {
          if (response.status === 200) {
            this.setState({
              commonData: {
                proId: response.data.proId,
                createdOn: response.data.createdDateTs,
                inPlanCount: response.data.planCount
              },
              gridData: response.data.proVersions ?? [],
              loading: false
            });
          } else {
            this.resetData();
          }
        },
        error => {
          this.resetData();
        }
      );
    } else {
      this.resetData();
      this.props.enqueueSnackbar(MESSAGES.PRO_HISTORY.EMPTY_PROID_SEARCH, {
        variant: "error"
      });
    }
  };

  render() {
    const { config } = this.gridConfig;
    const { classes } = this.props;
    return (
      <Fragment>
        <header
          className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}
        >
          <span>Pro History</span>
        </header>
        <div
          className={`${classes.gridContainer} ${classes.proHistoryGridContainer}`}
        >
          <div className={`${classes.gridHead}`}>
            <div className={classes.searchBoxContainer}>
              <SearchBox
                onChange={this.updateSearchText}
                customSearchClass={classes.customSearchWidth200}
                onEnter={this.fetchProHistory}
              />    
              <Button
                variant="contained"
                size="small"
                color="primary"
                classes={{ root: classes.buttonRoot }}
                onMouseDown={this.fetchProHistory}
                data-automationid="search"
              >
                Search
              </Button>
            </div>
            <ProHistoryHeader data={this.state.commonData} />
          </div>
           
          <div className={`${classes.dataGrid} ${classes.proHistoryGrid}`}>
            {this.state.loading ? (
              <AppLoading />
            ) : (
              <DataGrid
                defaultColDef={config.defaultColDef}
                columnDefs={config.columns}
                config={config}
                rowData={this.state.gridData}
                enableSorting={config.enableSorting}
                onGridReady={this.onGridReady}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(ProHistoryGrid);
